import type { FiltersPageFilterValues } from '@/pages/Filters/types/filters-filter-values';
import type { FiltersPageFilterQuery } from '@/pages/Filters/types/filters-query-params';

export const deserializeQueryParams = (query: FiltersPageFilterQuery) => {
  const filters: FiltersPageFilterValues = {
    page: query.page!,
    limit: query.limit!,
    projectId: query.projectId,
  };

  return filters;
};
